import { ApolloClient } from '@apollo/client';
import { NormalizedCacheObject } from '@apollo/client';
import { loader } from 'graphql.macro';
import { logger } from 'logging-utils';
import { AppOwnerType } from 'common-types';
const mutation = loader('./save-applications-owners.gql');

const saveApplicationsOwners = (
  client: ApolloClient<NormalizedCacheObject>,
) => {
  return {
    execute: async (appOwnerInput: AppOwnerInput) => {
      try {
        const results = await client.mutate<{
          setApplicationsOwners: {
            isUpdated: boolean;
          };
        }>({ mutation, variables: { appOwnerInput } });

        return results.data?.setApplicationsOwners;
      } catch (error) {
        logger.error('Failed to set applications owners', error);
        return null;
      }
    },
  };
};

export interface AppOwnerInput {
  appIds: string[];
  owners: AppOwnerType[];
  roles: string[];
}

export default saveApplicationsOwners;
